<template>
  <div class="height-100-p">
    <el-table
      :data="palletReceipt.list"
      v-loading="palletReceipt.loadingSearch"
      id="palletReceipt-data-list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
       @sort-change="handleSortChange"
       :default-sort = "{prop: 'dayOfService', order: 'descending'}"
      stripe>
     <el-table-column
        prop="dayOfService"
        :label="$t('palletReceipt.dayOfService')"
        :min-width="7"
        sortable="custom">
        <template slot-scope="scope">
          <span>{{ scope.row.dayOfService | moment(dateDisplayFormat) }}</span>
        </template>
      </el-table-column>
       <el-table-column
        prop="receiptNumber"
        :label="$t('palletReceipt.receiptNumber')"
        :min-width="6">
         <template slot-scope="scope">
            <span>{{ scope.row.receiptNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="redeemableNumber"
        :label="$t('palletReceipt.redeemableNumber')"
        :min-width="3">
         <template slot-scope="scope">
            <span>{{ scope.row.redeemableNumber }}</span>
        </template>
      </el-table-column>
       <el-table-column
        prop="palletStatus"
        :label="$t('palletReceipt.status')"
        :min-width="8"
        align="center">
        <template slot-scope="scope">
         <span>{{palletReceiptStatusLabel(scope.row.palletStatus)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="options" :label="$t('common.options')" :min-width="4" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="$t('palletReceipt.print')" placement="top-start">
            <i class="el-icon-printer icon-action" @click="print(scope.row.palletId)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-footer" v-show="palletReceipt.total > 0">
      <span class="el-pagination__total" slot>
        <span class="el-pagination__title" slot>{{ $t('palletReceipt.totalPallets') }}</span>
           {{ palletReceipt.total }}
      </span>
      <el-pagination
      @size-change="handleSearchChangeLimit"
      :page-sizes="sizes"
      :page-size="palletReceipt.actualFilters.rows"
      :current-page.sync="palletReceipt.actualFilters.page"
      @current-change="handleSearchChangePage"
      :total="palletReceipt.total"
      layout="slot, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import { PALLET_RECEIPT_SEARCH } from '@/store/actions';
import transformLabels from '@/plugins/unitDataTransformLabels';

export default {
  name: 'SearchSummary',
  mixins: [transformLabels],
  computed: {
    ...mapGetters(['palletReceipt']),
    dateDisplayFormat() {
      return constants.DATES.DEFAULT_DISPLAY_FORMAT;
    }
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  methods: {
    handleSearchChangePage(val) {
      this.$store.dispatch(PALLET_RECEIPT_SEARCH, { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch(PALLET_RECEIPT_SEARCH, { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSortChange({ prop, order }) {
      this.$store.dispatch(PALLET_RECEIPT_SEARCH, { orderField: prop, orderDirection: constants.TABLES.ORDER_DIRECTION[order] });
    },
    async print(palletReceiptId) {
      const loading = Loading.service(constants.LOADING.PRINT_PALLET_RECEIPT_CONFIG);
      await this.$store.dispatch('palletReceipt/print', palletReceiptId);
      loading.close();
    }
  }
};
</script>
